module.exports = __webpack_public_path__ + "img/icon-settings-light.d45e3d54.svg";